import * as Yup from "yup";
import {
  EMAIL_REGEX,
  nameRegex,
  passwordRegex,
  phoneRegex,
} from "../../../helpers";

export const addAdminValidationSchema = Yup.object({
  firstName: Yup.string()
    .matches(
      nameRegex,
      "First name must contain only letters and be at least 2 characters"
    )
    .required("First name is required"),
  lastName: Yup.string()
    .matches(
      nameRegex,
      "Last name must contain only letters and be at least 2 characters"
    )
    .required("Last name is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(
      EMAIL_REGEX,
      "Enter a valid email (e.g., user@example.com). Must not contain spaces, must include '@', and a valid domain."
    ),
  phoneNumber: Yup.string()
    .matches(phoneRegex, "Enter a valid phone number")
    .required("Phone number is required"),
  gender: Yup.string().required("Gender is required"),
  address: Yup.string().required("Address is required"),
  role: Yup.string().required("Role is required"),
  offices: Yup.string().when("role", ([role], schema) =>
    role === "COURIER_ADMIN" || role === "COURIER_AGENT"
      ? schema.required("Courier office is required")
      : schema.notRequired()
  ),
  country: Yup.string().when("role", ([role], schema) =>
    role === "COURIER_ADMIN" || role === "COURIER_AGENT"
      ? schema.required("Country is required")
      : schema.notRequired()
  ),
  username: Yup.string().required("Username is required"),
  password: Yup.string()
    .matches(
      passwordRegex,
      "Password must be at least 8 characters long, contain an uppercase letter, a lowercase letter, a number, and a special character"
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
});

export const editAdminValidationSchema = Yup.object({
  firstName: Yup.string()
    .matches(
      nameRegex,
      "First name must contain only letters and be at least 2 characters"
    )
    .required("First name is required"),
  lastName: Yup.string()
    .matches(
      nameRegex,
      "Last name must contain only letters and be at least 2 characters"
    )
    .required("Last name is required"),
  username: Yup.string().required("User name is required"),
  email: Yup.string()
    .required("Email is required")
    .matches(
      EMAIL_REGEX,
      "Enter a valid email (e.g., user@example.com). Must not contain spaces, must include '@', and a valid domain."
    ),
  phoneNumber: Yup.string()
    .matches(phoneRegex, "Enter a valid phone number")
    .required("Phone number is required"),
  roles: Yup.string().required("Role is required"),
  address: Yup.string().required("Branch/Location is required"),
});
